<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="$t('nextengine.nextengine_ec-receiveorder-detail-title')"
      :isFooter="true"
      :width="width"
      isCardColor="true"
    >
      <v-container class="pa-4">
        <v-card class="mb-4" outlined>
          <v-card-title class="section-title">
            {{ $t('nextengine.nextengine_ec-receiveorder-imformation') }}
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-up</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" md="4" class="info-col">
                <v-simple-table class="info-display-table">
                  <thead>
                    <tr>
                      <th colspan="2">
                        {{ $t('nextengine.nextengine_ec-receiveorder-purchaser-information') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-purchaser-name') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.purchaser.name }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('common.input_postal-code') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.purchaser.zipCode }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('common.address_address_0') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.purchaser.address }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('common.input_phone-number') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.purchaser.phone }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="4" class="info-col">
                <v-simple-table class="info-display-table">
                  <thead>
                    <tr><th colspan="2">{{ $t('nextengine.nextengine_ec-receiveorder-consignee-information') }}</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-consignee-name') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.destination.name }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('common.input_postal-code') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.destination.zipCode }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('common.address_address_0') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.destination.address }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('common.input_phone-number') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.destination.phone }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="4" class="info-col">
                <v-simple-table class="info-display-table">
                  <thead>
                    <tr><th colspan="2">{{ $t('nextengine.nextengine_ec-receiveorder-other-information') }}</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-receiveorder-id') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.otherInfo.slipNumber }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-receiveorder-shop-cut-form-id') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.otherInfo.orderNumber }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-shop-tax-id') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.otherInfo.shopTaxId }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-payment-method') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.otherInfo.paymentMethod }}</td>
                    </tr>
                    <tr>
                      <td class="label-cell">{{ $t('nextengine.nextengine_ec-receiveorder-receiveorder-date') }}</td>
                      <td class="value-cell">{{ tempEcReceiveorderData.otherInfo.orderDate }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined>
          <v-card-title class="section-title">
            {{ $t('nextengine.nextengine_ec-receiveorder-row-imformation') }}
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-up</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <div class="order-detail-table">
              <v-data-table
                :headers="orderDetailHeaders"
                :items="tempEcReceiveorderData.details"
                hide-default-footer
                class="elevation-0"
              >
                <template #item.productName="{ item }">
                  <div style="white-space: pre-wrap;">{{ item.productName }}</div>
                </template>
              </v-data-table>
            </div>
            <v-divider></v-divider>
            <div class="summary-area pa-4">
              <v-row>
                <v-col cols="12" md="8">
                  <v-row>
                    <v-col cols="2" sm="2" class="summary-item">
                      <span>{{ $t('nextengine.nextengine_ec-receiveorder-goods-amount') }}</span>
                      {{ (tempEcReceiveorderData.goodsAmount || 0).toLocaleString() }}
                    </v-col>
                    <v-col cols="2" sm="2" class="summary-item">
                      <span>{{ $t('nextengine.nextengine_ec-receiveorder-tax-amount') }}</span>
                      {{ (tempEcReceiveorderData.taxAmount || 0).toLocaleString() }}
                    </v-col>
                    <v-col cols="2" sm="2" class="summary-item">
                      <span>{{ $t('nextengine.nextengine_ec-receiveorder-charge-amount') }}</span>
                      {{ (tempEcReceiveorderData.chargeAmount || 0).toLocaleString() }}
                    </v-col>
                    <v-col cols="2" sm="2" class="summary-item">
                      <span>{{ $t('nextengine.nextengine_ec-receiveorder-delivery-fee-amount') }}</span>
                      {{ (tempEcReceiveorderData.deliveryFeeAmount || 0).toLocaleString() }}
                    </v-col>
                    <v-col cols="2" sm="2" class="summary-item">
                      <span>{{ $t('nextengine.nextengine_ec-receiveorder-point-amount') }}</span>
                      {{ (tempEcReceiveorderData.pointAmount || 0).toLocaleString() }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="d-flex justify-md-end align-center total-amount">
                  <span>{{ $t('common.input_total') }}</span>
                  <span class="amount">{{ (tempEcReceiveorderData.totalAmount || 0).toLocaleString() }}</span>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { i18n } from '@/main.js'

const createDefaultData = () => ({
  purchaser: { name: '', zipCode: '', address: '' },
  destination: { name: '', zipCode: '', address: '', phone: '' },
  otherInfo: { slipNumber: '', orderNumber: '', store: '', paymentMethod: '', orderDate: '' },
  details: [],
  subtotalsByTaxRate: {},
  taxByTaxRate: {},
  deliveryFee: 0,
  totalAmount: 0
})

export default {
  components: {
    DialogBase,
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    ecReceiveorderData: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    errDialog: false,
    tempEcReceiveorderData: createDefaultData(),
    orderDetailHeaders: [
      { text: i18n.tc('common.product_product-number'), value: 'productNumber', sortable: false, width: '12.5%' },
      { text: i18n.tc('common.product_product-name'), value: 'productName', sortable: false, width: '30%' },
      { text: i18n.tc('common.product_consumption-tax-rate'), value: 'taxRatePercentage', sortable: false, align: 'end', width: '7.5%' },
      { text: i18n.tc('sale.sale_rate-account'), value: 'wholesaleRetailRaito', sortable: false, align: 'end', width: '7.5%' },
      { text: i18n.tc('sale.sale_number-of-sales'), value: 'quantity', sortable: false, align: 'end', width: '7.5%' },
      { text: i18n.tc('sale.sale_unit-price'), value: 'unitPrice', sortable: false, align: 'end', width: '10%' },
      { text: i18n.tc('sale.sale_price'), value: 'amount', sortable: false, align: 'end', width: '12.5%' },
      // --- ▼ 変更点 ---
      { text: 'EC商品連携', value: 'linkedStatus', sortable: false, align: 'center', width: '10%' }
      // --- ▲ 変更点 ---
    ]
  }),
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      const propData = this.ecReceiveorderData
      if (!propData || Object.keys(propData).length === 0) {
        this.tempEcReceiveorderData = createDefaultData()
        return
      }

      const subtotalsByTaxRate = {}
      const taxByTaxRate = {}

      // --- ▼ 変更点 ---
      const details = (propData.ecReceiveOrderRows || []).map(row => {
        const subtotal = parseFloat(row.receiveOrderRowSubTotalPrice)
        const taxRate = parseFloat(row.receiveOrderRowTaxRate)
        const taxRateKey = taxRate.toFixed(0)

        return {
          productNumber: row.receiveOrderRowGoodsId,
          productName: row.receiveOrderRowGoodsName,
          taxRatePercentage: `${taxRateKey}%`,
          wholesaleRetailRaito: row.receiveOrderRowWholesaleRetailRatio,
          quantity: parseFloat(row.receiveOrderRowQuantity),
          unitPrice: parseFloat(row.receiveOrderRowUnitPrice),
          amount: subtotal,
          // linkProductIdが存在するかで連携状態を判定
          linkedStatus: row.ecGoods && row.ecGoods.linkProductId !== null ? '連携済み' : '未連携'
        }
      })
      // --- ▲ 変更点 ---

      this.tempEcReceiveorderData = {
        purchaser: {
          name: propData.receiveOrderPurchaserName,
          zipCode: propData.receiveOrderPurchaserZipCode,
          address: `${propData.receiveOrderPurchaserAddress1 || ''} ${propData.receiveOrderPurchaserAddress2 || ''}`.trim(),
          phone: propData.receiveOrderPurchaserTel
        },
        destination: {
          name: propData.receiveOrderConsigneeName,
          zipCode: propData.receiveOrderConsigneeZipCode,
          address: `${propData.receiveOrderConsigneeAddress1 || ''} ${propData.receiveOrderConsigneeAddress2 || ''}`.trim(),
          phone: propData.receiveOrderConsigneeTel
        },
        otherInfo: {
          slipNumber: propData.receiveOrderShopCutFormId,
          orderNumber: propData.receiveOrderId,
          shopTaxId:
            propData.shopTaxId == 1
              ? i18n.tc('nextengine.nextengine_ec-receiveorder-shop-tax-id-1')
              : i18n.tc('nextengine.nextengine_ec-receiveorder-shop-tax-id-2'),
          paymentMethod: propData.receiveOrderPaymentMethodName || '-',
          orderDate: propData.receiveOrderDate
            ? new Date(propData.receiveOrderDate).toLocaleDateString('ja-JP')
            : ''
        },
        details: details,
        goodsAmount: parseFloat(propData.receiveOrderGoodsAmount) || 0,
        taxAmount: parseFloat(propData.receiveOrderTaxAmount) || 0,

        chargeAmount: parseFloat(propData.receiveOrderChargeAmount) || 0,
        deliveryFeeAmount: parseFloat(propData.receiveOrderDeliveryFeeAmount) || 0,
        pointAmount: parseFloat(propData.receiveOrderPointAmount) || 0,

        totalAmount: parseFloat(propData.receiveOrderTotalAmount) || 0
      }
    },
  },
  computed: {
    inputValue: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal) { if (newVal) this.init() }
    },
    ecReceiveorderData: {
      deep: true,
      handler(newVal) { if (newVal) this.init() }
    }
  }
}
</script>

<style scoped lang="scss">
.section-title {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.info-col {
  padding: 0;
  &:not(:last-child) {
    border-right: 1px solid #d8d8d8;
  }
}

.info-display-table {
  th {
    font-size: 0.9rem;
    font-weight: bold;
    background-color: rgba(151, 198, 234, 0.1);
    text-align: left;
    padding: 8px 16px !important;
  }
  .label-cell {
    width: 35%;
    color: #616161;
    font-size: 0.875rem;
    padding: 4px 8px !important;
    height: 28px !important;
    border-bottom: none !important;
  }
  .value-cell {
    font-size: 0.875rem;
    padding: 4px 8px !important;
    height: 28px !important;
    word-break: break-all;
    border-bottom: none !important;
  }
  tr:last-child {
    td {
      border-bottom: none;
    }
  }
}

.summary-area {
  background-color: #f5f5f5;
}

.summary-item {
  color: #616161;
  font-size: 0.875rem;
  padding-top: 4px;
  padding-bottom: 4px;
}

.total-amount {
  font-size: 1rem;
  font-weight: bold;

  .amount {
    font-size: 1.75rem;
    margin: 0 4px 0 16px;
  }
}

.order-detail-table {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    font-weight: bold;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table td {
    border-collapse: collapse;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
    vertical-align: middle;
    padding: 16px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee !important;
  }
}
</style>